/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Search_Matched_OneInputs */

const en_search_matched_one = /** @type {(inputs: Search_Matched_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Matched ${i?.count} endpoint for your use case`)
};

const zh_hans1_search_matched_one = /** @type {(inputs: Search_Matched_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`为你的使用场景匹配到 ${i?.count} 个接口`)
};

const pt_br2_search_matched_one = /** @type {(inputs: Search_Matched_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} endpoint encontrado para o seu caso de uso`)
};

const es_search_matched_one = /** @type {(inputs: Search_Matched_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} endpoint coincide con tu caso de uso`)
};

const fr_search_matched_one = /** @type {(inputs: Search_Matched_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} endpoint correspond à votre cas d’usage`)
};

const de_search_matched_one = /** @type {(inputs: Search_Matched_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Endpoint für deinen Anwendungsfall gefunden`)
};

const ru_search_matched_one = /** @type {(inputs: Search_Matched_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Эндпоинтов, подходящих под вашу задачу: ${i?.count}`)
};

const it_search_matched_one = /** @type {(inputs: Search_Matched_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trovato ${i?.count} endpoint per il tuo caso d'uso`)
};

/**
* | output |
* | --- |
* | "Matched {count} endpoint for your use case" |
*
* @param {Search_Matched_OneInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_matched_one = /** @type {((inputs: Search_Matched_OneInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Matched_OneInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_matched_one(inputs)
	if (locale === "pt-BR") return pt_br2_search_matched_one(inputs)
	if (locale === "es") return es_search_matched_one(inputs)
	if (locale === "fr") return fr_search_matched_one(inputs)
	if (locale === "de") return de_search_matched_one(inputs)
	if (locale === "ru") return ru_search_matched_one(inputs)
	if (locale === "it") return it_search_matched_one(inputs)
	return en_search_matched_one(inputs)
});